"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidUserInputError = void 0;
class InvalidUserInputError extends Error {
    code = 422;
    name = 'InvalidUserInputError';
    constructor(...args) {
        super(...args);
        Error.captureStackTrace(this, InvalidUserInputError);
    }
}
exports.InvalidUserInputError = InvalidUserInputError;
//# sourceMappingURL=invalid-user-input-error.js.map